export default function isNumeric(value) {
    return /^-?\d+$/.test(value)
}
